import { newDocContent, type DocContent } from "./doc-content";

/**
 * Plain text as markdown that reads back as the same text: markup
 * characters are escaped, never parsed, and so are line starts that would
 * open a list, a heading underline or a rule.
 */
export function plainTextToMarkdown(text: string): string {
  return text
    .replace(/\r\n?/g, "\n")
    .replace(/[\\`*_#[\]<>~|]/g, "\\$&")
    .replace(/^(\s*)([-+=])/gm, "$1\\$2")
    .replace(/^(\s*\d+)([.)])/gm, "$1\\$2");
}

/**
 * A Doc holding plain text exactly: its blocks are written directly (one
 * paragraph per blank-line-separated part, a line break per newline), so
 * the editor never parses the text as markdown; the markdown snapshot is
 * the escaped text.
 */
export function plainTextDocContent(text: string): DocContent {
  const normalized = text.replace(/\r\n?/g, "\n");
  const markdown = plainTextToMarkdown(normalized);
  const blocks = normalized
    .split(/\n{2,}/)
    .filter((part) => part.trim() !== "")
    .map((part) => ({
      type: "paragraph",
      content: [{ type: "text", text: part, styles: {} }],
      children: [],
    }));
  return {
    ...newDocContent(markdown),
    blocks,
    text: normalized,
  };
}
